/**
 * iframe-embed-helper.js
 *
 * UI controls for the slider block
 */
(function($) {

	//disable scrolling on a map (smoother UX)
	$('#truelook-embed').click(function() {
	  $(this).children('iframe').css('pointer-events', 'auto');
	});

	$('#truelook-embed').mouseleave( function(){
	  $(this).children('iframe').css('pointer-events', 'none');
	});
	

})(jQuery);